function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
const SvgIconDownload = props => {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: "1em",
    height: "1em",
    viewBox: "0 0 15 19",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.286 0v6.429H0l7.5 7.5 7.5-7.5h-4.286V0H4.286zM0 18.214h15v-2.143H0v2.143z"
  }));
};
SvgIconDownload.propTypes = process.env.NODE_ENV !== "production" ? {
  title: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  fill: PropTypes.string,
  label: PropTypes.string
} : {};
export default SvgIconDownload;